export default "http://127.0.0.1:9007/dev-api"
// export default "http://192.168.1.63:9007/dev-api"



// WEBPACK FOOTER //
// ./src/api/baseAPI.js